<template>
    <div class="home">
        <Main :page-type="pageType" />
    </div>
</template>

<script>
// @ is an alias to /src
import Main from '@/components/Main.vue'

export default {
    name: 'Home',
    props: {
        pageType: {
            type: String,
        },
    },
    components: {
        Main,
    },
}
</script>
<style scoped>
.home {
    height: 100%;
}
</style>
<style>
body > .home {
    height: auto;
}
</style>
